import BaseComponent from '../abstracts/BaseComponent';
import Observer from '../utilities/Observer';
import Logger from '../libs/Logger';
import {match} from '../utilities/ResolutionHandler';

const log = new Logger('AnchorLinkComponent');

export default class AnchorLinkComponent extends BaseComponent {
  get SELECTORS() {
    return {
      anchorLink: ".js-anchor-link",
      mainSection: ".main-section",
      section: ".info-service",
      header: ".pre-header",
      asideBar: ".aside-sticky-bar",
    };
  }

  get CLASSES() {
    return {
      active: "is-active",
      scrollDown: "scroll-down",
    };
  }

  constructor(element) {
    super(element);
    this.observeAnchor();
    this.onScroll();
  }

  distanceToTop(el) {
    const preHeader = document.querySelector(this.SELECTORS.header);
    const mainSection = document.querySelector(this.SELECTORS.mainSection);
    const screenWidth = screen.width;
    let headerHeight = preHeader
      ? mainSection.offsetHeight + preHeader.offsetHeight
      : mainSection.offsetHeight;

    if (mainSection.classList.contains(this.CLASSES.scrollDown) && preHeader)
      headerHeight -= preHeader.offsetHeight;

    if (screenWidth < parseInt(window.mqObj.large)) {
      const asideStickyBar = document.querySelector(this.SELECTORS.asideBar);
      headerHeight += asideStickyBar.offsetHeight;
    }
    return Math.floor(el.getBoundingClientRect().top - headerHeight);
  }

  observeAnchor() {
    const linksToAnchors = document.querySelectorAll(this.SELECTORS.anchorLink);

    linksToAnchors.forEach((item) => {
      item.addEventListener(
        "click",
        (event) => {
          event.preventDefault();

          const eventTarget = this.checkClickOnElement(event.target);
          const targetID = eventTarget.getAttribute("href");
          const targetAnchor = document.querySelector(targetID);

          if (!targetAnchor) return;

          this.activateLink(eventTarget);

          const calculatedTop = this.distanceToTop(targetAnchor);

          window.scrollBy({ top: calculatedTop, left: 0, behavior: "smooth" });
        },
        true
      );
    });
  }

  checkClickOnElement(eventTarget) {
    // fix click on span inside href
    if (eventTarget && eventTarget.tagName !== "A")
      eventTarget = eventTarget.parentNode;
    return eventTarget;
  }

  activateLink(target) {
    const active = document.querySelector(`.${this.CLASSES.active}`);
    if (active) {
      active.classList.remove(this.CLASSES.active);
    }
    target.classList.add(this.CLASSES.active);
  }

  onScroll() {
    window.addEventListener(
      "scroll",
      this.throttle(() => this.handleObserver(), 100)
    );
  }

  getMediaQuery(currentSize) {
    if (match("medium", "small")) {
      currentSize = "small";
    } else if (match("large", "medium")) {
      currentSize = "medium";
    } else if (match(null, "large")) {
      currentSize = "large";
    }
    return currentSize;
  }

  throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function () {
      const context = this;
      const args = arguments;
      if (!lastRan) {
        func.apply(context, args);
        lastRan = Date.now();
      } else {
        clearTimeout(lastFunc);
        lastFunc = setTimeout(function () {
          if (Date.now() - lastRan >= limit) {
            func.apply(context, args);
            lastRan = Date.now();
          }
        }, limit - (Date.now() - lastRan));
      }
    };
  }

  handleObserver() {
    console.log("THROTTLE");
    new Observer(this.SELECTORS.section, 0, null, (entries, observer) => {
      let slideNum;
      entries.forEach((entry) => {
        /*// TO DO: is only 4 debug delete this
          entry.target.style.border = "none";*/
        //if (entry.intersectionRatio > 0 && (this.distanceToTop(entry.target) <= 100 && this.distanceToTop(entry.target) > 0)) {

        //console.log(this.distanceToTop(entry.target))

        if (entry.isIntersecting && this.distanceToTop(entry.target) <= 100) {
          // TO DO: is only 4 debug delete this
          //entry.target.style.border = "thick solid #BAD455";

          let targetID = `[href="#${entry.target.id}"]`;
          let target = document.querySelector(targetID);
          slideNum = target ? target.getAttribute("data-slide-num") : "";

          if (target) {
            this.activateLink(target);
          }

          observer.unobserve(entry.target);
        }
      });
      this.EMIT(this.CUSTOM_MESSAGES.CAROUSEL_EVENTS.goToSlide, {
        slide: slideNum,
      });
    });

    let currentSize = this.getMediaQuery(currentSize);

    if (currentSize !== "large") {
      const mainSection = document.querySelector(this.SELECTORS.mainSection);
      const asideStickyBar = document.querySelector(this.SELECTORS.asideBar);

      if (mainSection.classList.contains(this.CLASSES.scrollDown)) {
        asideStickyBar.style.top = `${mainSection.offsetHeight}px`;
      } else {
        const style = window.getComputedStyle(asideStickyBar);
        const top = style.getPropertyValue("top");
        asideStickyBar.style.top = top;
      }
    }
  }
}
